import React from "react";
import { Box } from "@mui/material";
import { StriimModal, StriimTypography } from "@striim/striim-ui";
import { AI_AGENT_NAME } from "../../ai-constants";
import styles from "./striim-ai-servers-modal.styles";

interface StriimAIServersModalProps {
    isVisible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    isLoading?: boolean;
}

const StriimAIServersModal: React.FC<StriimAIServersModalProps> = ({
    isVisible,
    onConfirm,
    onCancel,
    isLoading = false
}) => {
    return (
        <StriimModal
            size="medium"
            autoHeight
            isVisible={isVisible}
            onConfirm={onConfirm}
            onCancel={onCancel}
            variant="primary"
            confirmContent="Launch with Clara AI's Servers"
            titleContent={<StriimTypography variant="h2">Get Started with {AI_AGENT_NAME}</StriimTypography>}
            confirmButtonProps={{
                disabled: isLoading,
                "data-test-id": "confirm-striim-ai-servers"
            }}
        >
            <Box sx={styles.content}>
                <StriimTypography variant="body" sx={styles.mainText}>
                    Jumpstart your {AI_AGENT_NAME} experience with Striim&apos;s managed AI servers — powered by
                    industry-leading cloud LLM providers with zero configuration required.
                </StriimTypography>
                <StriimTypography variant="body4" sx={styles.disclaimerText}>
                    Note: Your messages are not used for model training purposes, but may be transmitted to our cloud
                    LLM provider partners to deliver the {AI_AGENT_NAME} experience.
                </StriimTypography>
            </Box>
        </StriimModal>
    );
};

export default StriimAIServersModal;
